export default __webpack_public_path__ + "static/media/Metal007_1K_Metalness.a758fc34.jpg";